// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 393 ? "1b36b0c3" : chunkId) + "." + {"74":"e5ca632f92b91ccb","393":"7daf667702ede91c"}[chunkId] + ".js";
};